<!-- <nav *ngIf="paginantion_type == 'normal'">
  <ul>
    <li class="pag-link">
      <button class="pointer" aria-label="Primeira" (click)="doDataIndex(1)">
        <span aria-hidden="true">&laquo;</span>
        <span class="sr-only">Primeira</span>
      </button>
    </li>
    <li class="pag-link" *ngFor="let page of pagination.pages; let p = index" [ngClass]="{ current_page: page == pagination.current_page }">
      <ng-container *ngIf="page != pagination.current_page">
        <button (click)="doDataIndex(page)">{{ page }}</button>
      </ng-container>
      <ng-container *ngIf="page == pagination.current_page">
        <span>{{ page }}</span>
      </ng-container>
      <span class="sr-only" *ngIf="page == pagination.current_page">(atual)</span>
    </li>
    <li class="pag-link">
      <a class="pointer" aria-label="Última" (click)="doDataIndex(pagination.total_pages)">
        <span aria-hidden="true">&raquo;</span>
        <span class="sr-only">Última</span>
      </a>
    </li>
  </ul>
</nav> -->
<ng-container *ngIf="paginantion_type == 'normal'">
  <nav class="flex items-center justify-between border-t border-gray-200 px-4 sm:px-0 mt-4 md:mt-0">
    <div class="-mt-px flex w-0 flex-1">
      <button (click)="doDataIndex(1)" class="inline-flex items-center md:border-t-2 md:border-transparent pr-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700">
        <svg class="mr-3 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M18 10a.75.75 0 01-.75.75H4.66l2.1 1.95a.75.75 0 11-1.02 1.1l-3.5-3.25a.75.75 0 010-1.1l3.5-3.25a.75.75 0 111.02 1.1l-2.1 1.95h12.59A.75.75 0 0118 10z" clip-rule="evenodd" />
        </svg>
        <span class="hidden md:flex"> Primeira</span>
      </button>
    </div>
    <div class="md:-mt-px flex-wrap w-64 md:w-fit justify-center items-center">
      <ng-container *ngFor="let page of pagination.pages; let p = index">
        <ng-container *ngIf="page != pagination.current_page">
          <button (click)="doDataIndex(page)" class="inline-flex items-center border-t-2 border-transparent px-4 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700">{{ page }}</button>
        </ng-container>
        <ng-container *ngIf="page == pagination.current_page">
          <!-- Current: "border-indigo-500 text-indigo-600", Default: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" -->
          <p class="inline-flex items-center md:border-t-2 md:border-pink-800 px-4 pt-4 text-sm font-medium text-pink-800" aria-current="page">{{ page }}</p>
        </ng-container>
      </ng-container>
    </div>

    <div class="-mt-px flex w-0 flex-1 justify-end">
      <button (click)="doDataIndex(pagination.total_pages)" class="inline-flex items-center md:border-t-2 md:border-transparent pl-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700">
        <span class="hidden md:flex"> Última </span>
        <svg class="ml-3 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M2 10a.75.75 0 01.75-.75h12.59l-2.1-1.95a.75.75 0 111.02-1.1l3.5 3.25a.75.75 0 010 1.1l-3.5 3.25a.75.75 0 11-1.02-1.1l2.1-1.95H2.75A.75.75 0 012 10z" clip-rule="evenodd" />
        </svg>
      </button>
    </div>
  </nav>
</ng-container>

<nav *ngIf="paginantion_type == 'infinite'">
  <ul>
    <li class="pag-link mr-2" [ngClass]="{ current: page == pagination.current_page }">
      <input type="text" class="form-control" placeholder="1" #goToPage value="{{ pagination.current_page }}" />
      <button type="button" class="btn btn-sm" (click)="doDataIndex(null)">Ir para a Página ...</button>
    </li>
    <li class="pag-link">
      <button class="btn" aria-label="Primeira" (click)="doDataIndex(1)" *ngIf="pagination.current_page > 1">
        <span aria-hidden="true">Primeira</span>
      </button>
    </li>
    <li class="pag-link" [ngClass]="{ current: page == pagination.current_page }" *ngIf="pagination.current_page > 1">
      <button class="btn" (click)="doDataIndex(pagination.current_page - 1)">&laquo; Anterior</button>
    </li>
    <li class="pag-link" [ngClass]="{ current: page == pagination.current_page }">
      <button class="btn" (click)="doDataIndex(pagination.current_page + 1)">&raquo; Próxima</button>
    </li>
  </ul>
</nav>
